import { ComponentProps, MouseEventHandler, RefObject } from 'react'
import { Button, Icon } from '@atoms'

export type IconButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
export type IconButtonVariantName = ComponentProps<typeof Button>['variant']

type IconButtonProps = Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'children'
> & {
    name: string
    icon?: ComponentProps<typeof Icon>['name']
    iconSize?: ComponentProps<typeof Icon>['size']
    size: ComponentProps<typeof Button>['size']
    onClick?: MouseEventHandler
    variant?: IconButtonVariantName
    className?: string
    children?: React.ReactNode
    buttonRef?: RefObject<HTMLButtonElement>
}

export const IconButton: React.FC<IconButtonProps> = (props) => {
    const {
        icon,
        size,
        iconSize,
        name,
        onClick,
        variant = 'solidPrimary',
        children,
        buttonRef,
        ...passedProps
    } = props

    return (
        <Button
            icon={icon}
            name={name}
            size={size}
            iconSize={iconSize}
            onClick={onClick}
            variant={variant}
            buttonRef={buttonRef}
            {...passedProps}
        >
            {children}
        </Button>
    )
}
